/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const PLT_LOGO = require("./res/images/vLogo.png");
export const BACKGROUND_IMAGE = require("./res/images/backgroundImg.png");
export const ORDINARY_DAY_IMAGE = require("./res/images/ordinary-day.webp");


export const IMAGES = [
    PLT_LOGO,
    BACKGROUND_IMAGE,
    
];
